import script from "./word-of-day.vue?vue&type=script&setup=true&lang=js"
export * from "./word-of-day.vue?vue&type=script&setup=true&lang=js"

import "./word-of-day.vue?vue&type=style&index=0&id=e9b41140&lang=css"

const __exports__ = script;

export default __exports__